/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScanActivationQrBody
 */
export interface ScanActivationQrBody {
    /**
     * The scanned QR code data (typically a URL)
     * @type {string}
     * @memberof ScanActivationQrBody
     */
    qrData: string;
    /**
     * The objective ID (objectiveTemplateId) within the activation
     * @type {string}
     * @memberof ScanActivationQrBody
     */
    objectiveId: string;
}

/**
 * Check if a given object implements the ScanActivationQrBody interface.
 */
export function instanceOfScanActivationQrBody(value: object): value is ScanActivationQrBody {
    if (!('qrData' in value) || value['qrData'] === undefined) return false;
    if (!('objectiveId' in value) || value['objectiveId'] === undefined) return false;
    return true;
}

export function ScanActivationQrBodyFromJSON(json: any): ScanActivationQrBody {
    return ScanActivationQrBodyFromJSONTyped(json, false);
}

export function ScanActivationQrBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScanActivationQrBody {
    if (json == null) {
        return json;
    }
    return {
        
        'qrData': json['qrData'],
        'objectiveId': json['objectiveId'],
    };
}

export function ScanActivationQrBodyToJSON(json: any): ScanActivationQrBody {
    return ScanActivationQrBodyToJSONTyped(json, false);
}

export function ScanActivationQrBodyToJSONTyped(value?: ScanActivationQrBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'qrData': value['qrData'],
        'objectiveId': value['objectiveId'],
    };
}

